import { notification_color_keys } from "utils/hooks";

// to coply link to clipboard
export const copyLink = (link, notify) => {
  if (navigator && navigator.clipboard) {
    navigator.clipboard.writeText(link);
    notify("Link Copied!", notification_color_keys.success);
  }
};
